/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ExportHistoryItemSchemaFormat = typeof ExportHistoryItemSchemaFormat[keyof typeof ExportHistoryItemSchemaFormat];


export const ExportHistoryItemSchemaFormat = {
  pdf: 'pdf',
  csv: 'csv',
  'csv+pdf': 'csv+pdf',
} as const;
